<div class="dash">

  <header class="dash-header">
    <div>
      <p class="dash-eyebrow">Workspace</p>
      <h1 class="dash-title">Projects</h1>
      <p class="dash-subtitle" data-testid="dashboard-subtitle">
        @if (loading) {
          Loading your projects…
        } @else {
          {{ projects.length }} {{ projects.length === 1 ? 'project' : 'projects' }} monitored
        }
      </p>
    </div>

    <div class="dash-actions">
      @if (isAdmin) {
        <a class="pw-btn pw-btn--ghost" routerLink="/main/admin/dashboard" data-testid="dashboard-admin">
          <i class="fa fa-shield" aria-hidden="true"></i> Admin
        </a>
      }
      <button class="pw-btn pw-btn--primary" (click)="addNewProject()" data-testid="dashboard-new-project">
        <i class="fa fa-plus" aria-hidden="true"></i> New project
      </button>
    </div>
  </header>

  @if (accessRequests().length; as count) {
    <a class="dash-notice" routerLink="/main/organization" data-testid="dashboard-access-requests">
      <span class="dash-notice__icon" aria-hidden="true"><i class="fa fa-user-plus"></i></span>
      <span class="dash-notice__text">
        <strong>
          @if (count === 1) {
            {{ accessRequests()[0].name }} asked to join your organization
          } @else {
            {{ count }} people asked to join your organization
          }
        </strong>
        <span>Review the {{ count === 1 ? 'request' : 'requests' }} and send an invitation.</span>
      </span>
      <span class="dash-notice__cta">Review <i class="fa fa-angle-right" aria-hidden="true"></i></span>
    </a>
  }

  @if (!loading && projects.length > 0) {
    <div class="dash-toolbar">
      <label class="dash-search">
        <i class="fa fa-search" aria-hidden="true"></i>
        <input type="search" placeholder="Search projects" [(ngModel)]="query" aria-label="Search projects"
          data-testid="dashboard-search" />
      </label>
    </div>
  }

  @if (loading) {
    <div class="dash-grid">
      @for (i of [1, 2, 3]; track i) {
        <div class="card card--skeleton" data-testid="dashboard-skeleton">
          <div class="sk sk--avatar"></div>
          <div class="sk sk--line"></div>
          <div class="sk sk--line sk--short"></div>
        </div>
      }
    </div>
  } @else if (projects.length === 0 && isMember()) {
    <div class="dash-empty" data-testid="dashboard-empty-member">
      <div class="dash-empty__icon"><i class="fa fa-users" aria-hidden="true"></i></div>
      <h2>No projects to show yet</h2>
      <p>You see the projects of your teams, and you’re not in a team with projects yet. Ask the owner of your organization to add you.</p>
      <a class="pw-btn pw-btn--ghost" routerLink="/main/organization/teams">
        <i class="fa fa-users" aria-hidden="true"></i> See your teams
      </a>
    </div>
  } @else if (projects.length === 0) {
    <div class="dash-empty" data-testid="dashboard-empty">
      <div class="dash-empty__icon"><i class="fa fa-heartbeat" aria-hidden="true"></i></div>
      <h2>No projects yet</h2>
      <p>Create a project to start tracking uptime, errors and traces.</p>
      <button class="pw-btn pw-btn--primary" (click)="addNewProject()" data-testid="dashboard-empty-create">
        <i class="fa fa-plus" aria-hidden="true"></i> Create your first project
      </button>
    </div>
  } @else {
    <div class="dash-grid">
      @for (proj of filteredProjects; track proj.uuid) {
        <article class="card card--project" data-testid="project-card">
          <app-project-avatar class="card__avatar" [name]="proj.name" [logoUrl]="proj.logo_url" />
          <div class="card__meta">
            <h3 class="card__name" [title]="proj.name">
              <!-- Stretched link: its ::after covers the card, so the whole card opens the project. -->
              <a class="card__open" routerLink="/main/project/{{ proj.uuid }}" data-testid="project-name">{{ proj.name }}</a>
            </h3>
            @if (relativeTime(proj.updated_at || proj.created_at); as when) {
              <span class="card__sub" data-testid="project-updated">Updated {{ when }}</span>
            }
          </div>
          <i class="fa fa-angle-right card__chevron" aria-hidden="true"></i>

          @if (proj.status_page_slug) {
            <a class="card__status" data-testid="project-status-page" href="/main/status/{{ proj.status_page_slug }}">
              <span class="card__dot"></span>
              /status/{{ proj.status_page_slug }}
              <i class="fa fa-external-link" aria-hidden="true"></i>
            </a>
          }
        </article>
      } @empty {
        <p class="dash-noresults" data-testid="dashboard-no-results">No projects match “{{ query }}”.</p>
      }

      @if (!query) {
        <button class="card card--new" (click)="addNewProject()" data-testid="dashboard-new-tile">
          <span class="card--new__plus"><i class="fa fa-plus" aria-hidden="true"></i></span>
          <span>New project</span>
        </button>
      }
    </div>
  }
</div>
